<template>
  <div class="overseas-page">
    <div class="main-content">
      <!-- 第一部分：英雄区域 -->
      <section class="hero-section">
        <div class="container">
          <AppHeader />
          
          <div class="hero-content">
            <h1 class="hero-title animate">涉外服务</h1>
            <h2 class="hero-subtitle animate">让法律更好的"走出去"</h2>
          </div>
        </div>
      </section>
      
      <!-- 第二部分：涉外服务列表 -->
      <section class="overseas-list-section" ref="overseasListSection">
        <div class="container">
          <h2 class="section-title animate-scroll">闻讼涉外争议解决方案</h2>
          <p class="section-subtitle animate-scroll">中国企业全球化发展的争议解决护航专家</p>
          
          <div class="service-content">
            <p class="service-paragraph animate-scroll" style="animation-delay: 0.1s;">
              闻讼正在构建覆盖亚非拉美欧的全球律师协作网络，为中国企业提供专业高效的跨境争议解决方案。我们精选日本、韩国、东南亚、中东、欧洲、拉美、南非等地区精英律师，在国际贸易、知识产权、海外投资等领域，提供兼具本土化深度与国际化视野的法律服务。通过多种精准渠道对接当地资深律师，配合标准化流程管理与商业导向策略，确保每个案件获得最优解决方案。
            </p>
            
            <p class="service-paragraph animate-scroll" style="animation-delay: 0.2s;">
              基于服务多家中国500强企业的成功经验，闻讼独创"全周期+双地协同"服务模式：国内专业团队与海外律师紧密配合，从案件评估、策略制定到判决执行全程透明化管理；结案后专项复盘，将实战经验转化为企业风控能力。
            </p>
            
            <p class="service-paragraph animate-scroll" style="animation-delay: 0.3s;">
              无论是复杂的国际商事纠纷，还是棘手的跨境劳资争议，我们都能快速响应，通过建设多国资源网络与完善服务体系，为客户提供专业可靠的一站式解决方案，让企业在国际化征程中行稳致远。
            </p>
          </div>
          
          <!-- <div class="service-features">
            <div class="feature-item animate-scroll" style="animation-delay: 0.4s;">
              <div class="feature-icon">
                <img src="@/assets/image/group1@2x.png" alt="全球网络">
              </div>
              <h3 class="feature-title">全球律师协作网络</h3>
              <p class="feature-desc">覆盖亚非拉美欧各地区精英律师资源</p>
            </div>
            
            <div class="feature-item animate-scroll" style="animation-delay: 0.5s;">
              <div class="feature-icon">
                <img src="@/assets/image/group2@2x.png" alt="专业服务">
              </div>
              <h3 class="feature-title">专业领域服务</h3>
              <p class="feature-desc">国际贸易、知识产权、海外投资等</p>
            </div>
            
            <div class="feature-item animate-scroll" style="animation-delay: 0.6s;">
              <div class="feature-icon">
                <img src="@/assets/image/group3@2x.png" alt="服务模式">
              </div>
              <h3 class="feature-title">"全周期+双地协同"</h3>
              <p class="feature-desc">国内团队与海外律师紧密配合</p>
            </div>
            
            <div class="feature-item animate-scroll" style="animation-delay: 0.7s;">
              <div class="feature-icon">
                <img src="@/assets/image/group4@2x.png" alt="解决方案">
              </div>
              <h3 class="feature-title">一站式解决方案</h3>
              <p class="feature-desc">让企业在国际化征程中行稳致远</p>
            </div>
          </div> -->
        </div>
      </section>
    </div>
    <div class="footer-wrapper">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';

export default {
  name: 'OverseasService',
  components: {
    AppFooter,
    AppHeader
  },
  data() {
    return {
      observers: []
    }
  },
  mounted() {
    this.initScrollAnimations();
    
    // 首屏动画自动播放
    const animateElements = document.querySelectorAll('.animate');
    animateElements.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('visible');
      }, 300 * index);
    });
  },
  beforeUnmount() {
    // 清除所有观察者
    this.observers.forEach(observer => observer.disconnect());
  },
  methods: {
    initScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      
      const sections = [
        this.$refs.overseasListSection
      ];
      
      sections.forEach(section => {
        if (section) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const animatedElements = entry.target.querySelectorAll('.animate-scroll');
                animatedElements.forEach(el => {
                  el.classList.add('visible');
                });
              }
            });
          }, options);
          
          observer.observe(section);
          this.observers.push(observer);
        }
      });
    }
  }
}
</script>

<style scoped>
.overseas-page {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.footer-wrapper {
  flex-shrink: 0;
}

/* 入场动画基础样式 */
.animate, .animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}

.animate.visible, .animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 英雄区域样式 */
.hero-section {
  width: 1920px;
  height: 600px;
  background-image: url('~@/assets/image/swfw.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 322px;
}

.hero-title {
  font-weight: 600;
  font-size: 48px;
  color: #FFFFFF;
  margin: 0;
}

.hero-subtitle {
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  margin-top: 20px;
}

/* 涉外服务列表部分样式 */
.overseas-list-section {
  width: 1920px;
  background: #FFFFFF;
  padding: 60px 0;
  position: relative;
  overflow: hidden;
}

.section-title {
  font-weight: 600;
  font-size: 36px;
  color: #333333;
  text-align: left;
  margin-bottom: 20px;
}

.section-subtitle {
  font-size: 24px;
  color: #333333;
  margin-bottom: 40px;
  text-align: left;
}

.service-content {
  margin-bottom: 60px;
}

.service-paragraph {
  font-size: 24px;
  color: #333333;
  line-height: 1.8;
  text-align: justify;
  margin-bottom: 24px;
}

.service-features {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 60px;
}

.feature-item {
  width: 270px;
  background: #FFFFFF;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 20px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
}

.feature-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.feature-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 10px;
}

.feature-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}

.page-link {
  width: 36px;
  height: 36px;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  color: #333333;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.3s ease;
}

.page-link.active {
  background-color: #3578E5;
  color: #FFFFFF;
  border-color: #3578E5;
}

.page-link:hover:not(.active) {
  border-color: #3578E5;
  color: #3578E5;
}
</style> 